import React, {
 createContext, useState, useEffect, useMemo, 
} from 'react';
import PropTypes from 'prop-types';

export const AuthContext = createContext();

const AuthContextProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [userid, setUserId] = useState('');
  const [countryid, setCountryId] = useState('');


   const [apiGlobal, setApiGlobal] = useState('https://navrang.mvd-tech.io/API/'); // for development

  // const [apiGlobal, setApiGlobal] = useState('https://admin.bitevize.com/API/'); // for Production

  const value = useMemo(() => ({ 
    isLoggedIn, 
    setIsLoggedIn, 
    username, 
    setUsername,
    apiGlobal,
    setApiGlobal,
    userid,
    setUserId,
    countryid,
    setCountryId,
  }), [isLoggedIn, username, apiGlobal, userid, countryid]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

AuthContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthContextProvider;

